import styles from './PromoCtaPill.module.scss';

type PromoCtaPillProps = {
  label: string;
};

export function PromoCtaPill({ label }: PromoCtaPillProps) {
  return (
    <span className={styles.pill}>
      <span className={styles.icon}>
        <svg
          className={styles.glyph}
          viewBox="0 0 38.1385 47.4411"
          fill="none"
          focusable="false"
          aria-hidden="true"
        >
          <path
            d="M4.32508 0.649166L36.7015 21.4943C38.3238 22.5384 38.3238 24.9036 36.7015 25.9487L4.32508 46.7919C2.55479 47.9315 0.220313 46.6653 0.220313 44.5647V2.87636C0.220313 0.775787 2.55479 -0.490418 4.32508 0.649166Z"
            fill="currentColor"
            stroke="#ffffff"
            strokeWidth="0.440625"
            strokeMiterlimit="10"
          />
        </svg>
      </span>
      {label}
    </span>
  );
}
